import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Image, Dimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { useTranslation } from 'react-i18next';
import { Ionicons } from '@expo/vector-icons';
import LottieView from 'lottie-react-native';

const ErrorFallback = ({ error, resetError }) => {
  const { t } = useTranslation();
  const { width, height } = Dimensions.get('window');

  return (
    <LinearGradient
      colors={['#EAE5EE', '#FEE6DE', '#EBE5F2']}
      style={styles.container}
    >
      <View style={styles.content}>
        <View style={{width: '50%'}}><LottieView
          source={require('../../assets/animations/Animation - 1746448734469.json')}
          autoPlay
          loop
          resizeMode="contain"
          webStyle={styles.lottieAnimation}
          style={styles.lottieAnimation}
        /></View>

        <Text style={styles.title}>{t('error_occurred')}</Text>
        <Text style={styles.description}>{t('error_boundary_description')}</Text>

        {error && error.message && (
          <View style={styles.errorMessageContainer}>
            <Text style={styles.errorMessage}>{error.message}</Text>
          </View>
        )}

        <TouchableOpacity
          style={styles.button}
          onPress={resetError}
        >
          <Text style={styles.buttonText}>{t('try_again')}</Text>
        </TouchableOpacity>
      </View>
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    width: '80%',
    alignItems: 'center',
    padding: 20,
    borderRadius: 10,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  lottieAnimation: {
    width: 250,
    height: 250,
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
    color: '#1F2732',
  },
  description: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: 'center',
    color: '#2F2F2F',
  },
  errorMessageContainer: {
    backgroundColor: 'rgba(237, 28, 36, 0.1)',
    padding: 10,
    borderRadius: 5,
    marginBottom: 20,
    width: '100%',
  },
  errorMessage: {
    color: '#ED1C24',
    textAlign: 'center',
  },
  button: {
    backgroundColor: '#f6821f',
    paddingVertical: 12,
    paddingHorizontal: 30,
    borderRadius: 25,
    marginTop: 10,
  },
  buttonText: {
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default ErrorFallback;
